import { connect } from 'react-redux';

import { actionCreateGift } from 'store/gift/actions';
import { UPLOAD_MULTIPLE_MEDIA } from 'store/media/actionTypes';

import ManagerGiftCreate from './ManagerGiftCreate';

const mapStateToProps = (state) => ({
  isLoadingUploadMultipleMedia: state.Media.isLoadingUploadMultipleMedia,
  isCreateGiftLoading: state.Gift.createLoading,
});

const mapDispatchToProps = (dispatch) => ({
  actionUploadMultiMedia: (payload) => dispatch({
    type: UPLOAD_MULTIPLE_MEDIA,
    payload,
  }),
  actionCreateGift: (payload) => dispatch(actionCreateGift(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ManagerGiftCreate);
